<template>
    <div class="bg">
        <vueHeader :navNum='5'></vueHeader>

        <div class="banner">
            <img src="./../assets/img/contact/banner.jpg" alt="">
        </div>

        <div class="content wrap">
            <div class="map-box">
                <img class="map" src="./../assets/img/contact/map.png" />
                <div class="point point1"></div>
                <div class="point point2"></div>
                <div class="point point3"></div>
                <div class="city1 city" :class="{active:0==active}" @click="enter(0)"><img src="./../assets/img/contact/city1.png" alt=""></div>
                <div class="city2 city" :class="{active:1==active}" @click="enter(1)"><img src="./../assets/img/contact/city2.png" alt=""></div>
                <div class="city3 city" :class="{active:2==active}" @click="enter(2)"><img src="./../assets/img/contact/city3.png" alt=""></div>
                <div class="item" :class="{active:index==active}" v-for="(item,index) in infomation" :key="index">
                    <div class="name">{{item.title}}</div>
                    <div class="left">
                        <p><span>联系电话：</span><span>{{item.mobile}}</span></p>
                        <p><span>公司邮箱：</span><span>{{item.email}}</span></p>
                    </div>
                    <div class="right">
                        <p><span>办公地址：</span><span>{{item.addressCopy}}</span></p>
                        <p v-show="item.fax!=''"><span>公司传真：</span><span>{{item.fax}}</span></p>
                    </div>
                </div>
            </div>
            <div class="info">
                <div class="item" v-for="(item,index) in infomation" :key="index" @click="active=index">
                    <div class="name">{{item.title}}</div>
                    <div class="text"><span>联系电话：</span><p>{{item.mobile}}</p></div>
                    <div class="text"><span>公司邮箱：</span><p>{{item.email}}</p></div>
                    <div class="text"><span>办公地址：</span><p v-html="item.address"></p></div>
                    <div class="text" v-show="item.fax!=''"><span>公司传真：</span><p>{{item.fax}}</p></div>
                </div>
            </div>
        </div>

        <vueFooter></vueFooter>
    </div>
</template>

<script>
import vueHeader from '@/components/header'
import vueFooter from '@/components/footer'
export default {
    data() {
        return {
            active: -1,
            infomation: [
                {
                    numberImg: require('./../assets/img/contact/01.png'),
                    activeImg: require('./../assets/img/contact/01_active.png'),
                    title: '中国杭州办公室',
                    mobile: '+86-571-85310820 / +86-571-85310835',
                    address: '余杭区绿汀路21号浙富西溪堂3号楼8楼及9楼',
                    addressCopy: '余杭区绿汀路21号浙富西溪堂3号楼8楼及9楼',
                    email: 'info@lotohof.com',
                    fax: '+86-571-85310820-800'
                },
                {
                    numberImg: require('./../assets/img/contact/02.png'),
                    activeImg: require('./../assets/img/contact/02_active.png'),
                    title: '德国萨尔州办公室',
                    mobile: '+49 6865 1869 334',
                    address: 'Reiterhof Am Bärenfels 1, 66693<br />Mettlach Deutschland',
                    addressCopy: 'Reiterhof Am Bärenfels 1, 66693 Mettlach Deutschland',
                    email: 'info@lotohof.com',
                    fax: '+49 6865 1869 335'
                },
                {
                    numberImg: require('./../assets/img/contact/03.png'),
                    activeImg: require('./../assets/img/contact/03_active.png'),
                    title: '德国石荷州办公室',
                    mobile: '+49 6865 1869 661',
                    address: 'Am Alten Leuchtfeuer 14, 24340<br />Eckernförde Deutschland',
                    addressCopy: 'Am Alten Leuchtfeuer 14, 24340 Eckernförde Deutschland',
                    email: 'info@lotohof.com',
                    fax: '+49 6865 1869 662'
                }
            ]
        }
    },

    mounted() {
        window.scrollTo(0, 0);
    },

    methods: {
        enter(index) {
            
            if (index == this.active) {
                this.active = -1;
            }else{
                this.active = index;
            }
        },
    },

    components: {
        vueHeader,
        vueFooter
    },
}

</script>

<style scoped lang='less'>
@import "./../assets/css/contact.less";
</style>


// WEBPACK FOOTER //
// src/views/contact.vue